module.exports = __webpack_public_path__ + "img/1080_22.d0ba5d4f.jpg";